import { TextOverflowTooltip } from "@components";
import { Stack, TableCell, Typography } from "@mui/material";
import { OrderSearchOut } from "@providers/hop-ord-server/api";

interface Props {
  order: OrderSearchOut;
  index: number;
}
const CareplanCell = ({ order, index }: Props) => {
  return (
    <TableCell>
      <Stack
        sx={{
          gap: 0.5,
        }}
      >
        {order.orderName === "New Order" ? (
          <TextOverflowTooltip
            variant="body2"
            data-testid={`${index}-prescription-name`}
            noWrap={false}
            multilineText={true}
            arrow
            color="text.secondary"
            sx={{
              display: "-webkit-box",
              overflow: "hidden",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2,
              fontStyle: "italic",
            }}
          >
            Draft
          </TextOverflowTooltip>
        ) : (
          <TextOverflowTooltip
            variant="body2"
            data-testid={`${index}-prescription-name`}
            noWrap={false}
            multilineText={true}
            arrow
            sx={{
              display: "-webkit-box",
              overflow: "hidden",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2,
            }}
          >
            {order.orderName}
          </TextOverflowTooltip>
        )}
      </Stack>

      {order.planDelivery === "emergency" && (
        <Typography
          variant="body2"
          color="error"
          sx={{ textTransform: "capitalize", paddingTop: 0.2 }}
        >
          {order.planDelivery}
        </Typography>
      )}
    </TableCell>
  );
};

export default CareplanCell;
